//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { QueryRenderer } from "react-relay";
import { ReadyState } from "react-relay";
// team-health-summary-renderer imports
import { IRendererProps, IRendererContainer } from "./ProfileWorkingPreferences.d";
import { query } from "./ProfileWorkingPreferencesRenderer.gql";
import * as s from "./ProfileWorkingPreferences.styles";
// other internals
import { ProfileWorkingPreferences } from "./ProfileWorkingPreferences";
import { IReduxState } from "@reducers/root.reducer";
import { H2 } from "@ui";
import { handleReadyStateError } from "@util/relay.util";
import { CircularProgress } from "@clockwise/web-commons/src/components/circular-progress";
// material-ui
import { Divider } from "@material-ui/core";

//////////////////
// COMPONENT
//////////////////
class ProfileWorkingPreferencesRendererComponent extends React.PureComponent<IRendererProps> {
  // ~-~-~-~-~-~-~-
  // Rendering
  // ~-~-~-~-~-~-~-
  private maybeRenderProfileWorkingPreferences = (readyState: ReadyState) => {
    const freshOrg = readyState.props && readyState.props.node;

    // check for error or show a loader for first load
    if (readyState.error) {
      handleReadyStateError(readyState.error, "ProfileWorkingPreferencesRenderer");

      return null;
    }

    if (freshOrg) {
      return <ProfileWorkingPreferences org={freshOrg} />;
    } else {
      return (
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </div>
      );
    }
  };

  public render() {
    const { org, userId, nonUserCalendarId, environment } = this.props;
    const userIds = userId ? [userId] : [];
    const nonUserCalendarIds = [nonUserCalendarId];

    return (
      <QueryRenderer
        environment={environment}
        query={query}
        variables={{
          nonUserCalendarIds,
          userIds,
          orgRelayId: org.id,
          teamHealthCalendarId: nonUserCalendarId,
        }}
        cacheConfig={{}}
        render={(readyState) => {
          return (
            <div>
              <Divider style={s.divider} />
              <H2 style={s.title}>Working preferences</H2>
              {this.maybeRenderProfileWorkingPreferences(readyState)}
            </div>
          );
        }}
      />
    );
  }
}

//////////////////
// REDUX
//////////////////
export const ProfileWorkingPreferencesRenderer = connect(
  (_state: IReduxState, _ownProps: IRendererContainer) => ({}),
  {},
)(ProfileWorkingPreferencesRendererComponent);
